export const ALLOW_FILE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'video/mp4',
  'video/mov',
]

// 500MB
export const MAX_FILE_SIZE = 1024 * 1024 * 500
